import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ResourceNotFound } from '@pv/common/components';
import { ContactForm as ContactFormComponent } from '@pv/common/pages/ContactForm';

enum SearchParams {
  FormType = 'form-type',
  GoogleTagManagerId = 'google-tag-manager-id',
}
enum FormType {
  Venue = 'venue',
  Organization = 'organization',
  Concept = 'concept',
}

const DATA_LAYER_EVENT_NAME = 'perfect-venue-contact-form-submit';

//
const notifyDataLayer = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: DATA_LAYER_EVENT_NAME,
    });
  }
};

export default function ContactForm() {
  const { widgetInstanceId } = useParams();
  const [params] = useSearchParams();
  const formType = params.get(SearchParams.FormType);

  if (!widgetInstanceId || !formType) {
    return <ResourceNotFound resourceName={'Contact Form'} />;
  }

  const getEntityType = () => {
    if (formType === FormType.Venue) {
      return 'Venue';
    }
    if (formType === FormType.Organization) {
      return 'Organization';
    }
    if (formType === FormType.Concept) {
      return 'VenueCollection';
    } else {
      return 'Venue';
    }
  };

  const entityType = getEntityType();

  return (
    <ContactFormComponent
      entityId={widgetInstanceId}
      entityType={entityType}
      isWidget
      afterSubmit={notifyDataLayer}
    />
  );
}
